import React from "react";
import { decorate, observable } from "mobx";

class UiStore {
  constructor() {
    this.selectedSeasons = ["2022"]; // Default to the current year
  }
}

decorate(UiStore, {
  selectedSeasons: observable
});

export default UiStore;
export const UiStoreContext = React.createContext({ ...new UiStore() });
export const useUiStore = () => React.useContext(UiStoreContext);
